export const getHermitageData = () => ({
  name: "Hermitage",
  region: "Rhône",
  country: "France",
  description: "Hermitage est l'une des appellations les plus prestigieuses du Rhône septentrional, produisant des vins rouges puissants et des vins blancs complexes sur la colline de l'Hermitage.",
  type: "subregion",
  area: "140 ha",
  production: "7,000 hectolitres",
  mapAreas: [
    { region: "Hermitage", x: 53, y: 66, color: "#4B164C", size: 4 }
  ],
  characteristics: {
    climate: "Climat continental avec influence méditerranéenne",
    soil: "Sols de granit, schiste et micaschiste, exposition sud",
    viticulture: "Viticulture en terrasses, vendanges manuelles, rendements très limités"
  },
  wineStyles: {
    red: "Vins rouges puissants et structurés, avec des notes de fruits noirs et d'épices",
    white: "Vins blancs complexes et riches, avec des notes de miel et de fruits secs"
  },
  history: "Hermitage produit des vins depuis l'époque romaine. L'appellation est reconnue depuis 1937. La colline de l'Hermitage est un site historique de la viticulture rhodanienne.",
  foodPairing: "Viandes rouges, gibier, fromages affinés, cuisine gastronomique",
  grapeVarieties: [
    {
      name: "Syrah",
      percentage: "80%",
      description: "Cépage principal pour les vins rouges, produisant des vins puissants et structurés",
      characteristics: "Puissant, structuré, tanins fermes, notes de fruits noirs et d'épices",
      wineStyles: "Sec, plein-corps, tannique"
    },
    {
      name: "Marsanne",
      percentage: "15%",
      description: "Cépage principal pour les vins blancs, apportant richesse et complexité",
      characteristics: "Riche, complexe, notes de miel et de fruits secs",
      wineStyles: "Sec, plein-corps, complexe"
    },
    {
      name: "Roussanne",
      percentage: "5%",
      description: "Cépage d'assemblage pour les vins blancs, apportant élégance et aromatique",
      characteristics: "Élégant, aromatique, notes florales et d'agrumes",
      wineStyles: "Sec, moyen-corps, aromatique"
    }
  ]
}); 